import React from 'react';
import PropTypes from 'prop-types';
import Boutton from '@piconetworks/pkg-boutton';
import styles from '../scss/Success.module.scss.js';

var Icon = function Icon() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "40",
    height: "40",
    fill: "none",
    viewBox: "0 0 40 40"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#28BF6F",
    fillRule: "evenodd",
    d: "M20 40c11.046 0 20-8.954 20-20S31.046 0 20 0 0 8.954 0 20s8.954 20 20 20zM8.637 17.747a2.32 2.32 0 00.002 3.195l6.98 7.393c.854.89 2.222.883 3.07 0l12.677-13.452c.84-.874.85-2.32.003-3.208-.853-.895-2.215-.898-3.057-.022l-11.159 11.87-5.44-5.771a2.118 2.118 0 00-3.076-.005z",
    clipRule: "evenodd"
  }));
};
var Success = function Success(_ref) {
  var _ref$onClick = _ref.onClick,
    _onClick = _ref$onClick === void 0 ? function () {} : _ref$onClick,
    _ref$email = _ref.email,
    email = _ref$email === void 0 ? '' : _ref$email,
    _ref$phone = _ref.phone,
    phone = _ref$phone === void 0 ? '' : _ref$phone,
    contrastColor = _ref.contrastColor;
  return /*#__PURE__*/React.createElement("div", {
    className: styles.container
  }, /*#__PURE__*/React.createElement(Icon, null), /*#__PURE__*/React.createElement("p", null, "You're signed up for ", email ? 'email' : 'text', " updates at", /*#__PURE__*/React.createElement("br", null), email || phone, "."), /*#__PURE__*/React.createElement(Boutton, {
    variant: "primary",
    onClick: function onClick(e) {
      e.preventDefault();
      _onClick();
    },
    style: {
      color: contrastColor
    },
    className: styles.button
  }, "Manage Account"));
};
Success.propTypes = {
  contrastColor: PropTypes.string,
  email: PropTypes.string,
  onClick: PropTypes.func,
  phone: PropTypes.string
};
var MemoizedSuccess = /*#__PURE__*/React.memo(Success);
MemoizedSuccess.displayName = 'FieldSignupSuccess';
var Success$1 = MemoizedSuccess;

export { Success, Success$1 as default };
//# sourceMappingURL=index.js.map
